//import Libraries
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Modal} from 'reactstrap';
import * as axios from 'axios'

import {storageRef} from '../../../../../firebase';

import CardModal from './CardModal';

//import Components

//import Style classes
import './HiddenContent.css';

class CardsType extends Component{
    state = {
        openIndex: -1,
        modalContent : '',
        filteredItems : []
    }

    filterItems = () => {
        const filteredCards = this.props.cards.items.filter(item => {
            for(let i = 0; i < this.props.data.items.length; ++i) {
                if(this.props.data.items[i] === item.id)    
                    return true;
            }
        });
        let sortedCards = filteredCards && filteredCards.sort((a, b) => {
            return a.order - b.order; 
        });

        this.setState({
            filteredItems : sortedCards 
        })
    }

    componentDidUpdate = (prevProps, prevState, snapshot) => {
        if(this.props.data.name.ko !== prevProps.data.name.ko) {
            this.filterItems();
        }
        if(this.state.openIndex !== -1 && (prevState.openIndex !== this.state.openIndex)) {
            this.loadHTMLContentFromStorage(this.state.filteredItems[this.state.openIndex].id);
        }
    }

    componentDidMount() {
        this.filterItems();
    }

    clickHandler = (idx) => {
        this.setState({modalContent : ''})

        if(this.state.openIndex == -1) this.setState({openIndex: idx});
        if(this.state.openIndex !== -1 && this.state.openIndex !== idx) this.setState({openIndex: idx});
        if(this.state.openIndex !== -1 && this.state.openIndex === idx) this.setState({openIndex: -1});
    }

    closeCardModal = () => {
        this.setState({openIndex: -1})
    }

    loadHTMLContentFromStorage = (id) => {
        const articleRef = storageRef.child(`cards/${id}.html`);
        articleRef.getDownloadURL()
            .then((url) => {
                axios.get(url, { })
                    .then((res) => {
                        console.log(res.data);
                        this.setState({
                            modalContent : res.data
                        })
                    })
                    .catch((e)=>{
                    })
            })
            .catch((e) => {
            })
    }


    render(){
        const images = this.state.filteredItems.map((obj, idx)=>{
            
            return 
        })


        const cardModal = this.state.openIndex !== -1 ? 
            <Modal className="CustomModal"
                isOpen={this.state.openIndex !== -1 ? true : false} 
                toggle={this.closeCardModal}
                onClosed={true}
            >
                <CardModal 
                    title={this.state.filteredItems[this.state.openIndex].name['ko']}
                    text={this.state.modalContent}
                    closeCardModal={this.closeCardModal}
                />
            </Modal> : null


        const cards = this.state.filteredItems.map((obj, idx)=>{
            // console.log("cardhover image", this.props.urls)
            return <div className={this.state.openIndex == idx ? "Card active" : "Card"} onClick={()=>this.clickHandler(idx)} key={idx}>
                <h5>{obj.name[this.props.lang]}</h5>
                <p>{obj.content[this.props.lang]}</p>
                <div className="CardHoverImage">
                    <img src={this.props.urls[idx]} alt=""/>
                </div>
            </div>
        })
        const placeHolder = 
            <div className="PlaceHolder">
                <p>{this.props.lang === "ko" ? "세부항목을\n선택합니다" : "Select \n Detail Item"}</p>
                <svg version="1.1" x="0px" y="0px" width="69px" height="69px" viewBox="0 0 69 69" enableBackground="new 0 0 69 69">
                    <path d="M34.5,0C15.446,0,0,15.446,0,34.5S15.446,69,34.5,69S69,53.554,69,34.5S53.554,0,34.5,0z M53.75,36.281H36.281V53.75h-3.563
                        V36.281H15.25v-3.563h17.469V15.25h3.563v17.469H53.75V36.281z"/>
                </svg>
            </div>
        return(
            <React.Fragment>
                {cardModal}
                <div className={"HiddenContent CardsType"}>
                    {placeHolder}
                    <div className="CardImage">
                        {images}
                    </div>
                    <div className="Cards">
                        {cards}
                    </div>
                    <div className="CardsTypeContent Content">
                        <h3>{this.props.data.name[this.props.lang]}</h3>
                        <p>{this.props.data.content[this.props.lang]}</p>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        cards : state.company[2],
    }
}

export default connect(mapStateToProps, null)(CardsType);

CardsType.propTypes = {
    data: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/DepartmentModule/Contents/ContentCard/HiddenContent/CardsType.js